import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["detail"]

  connect() {
    this.detailTargets.forEach((detail) => {
      this.hideDetail(detail)
    })
  }

  toggle(event) {
    const btn = event.currentTarget
    const parentRow = btn.closest("tr")
    if (!parentRow) return

    const detailRow = parentRow.nextElementSibling
    if (!detailRow) return

    const isOpen = btn.textContent.trim() === "▼"

    if (isOpen) {
      btn.textContent = "▶"
      this.hideDetail(detailRow)
    } else {
      btn.textContent = "▼"
      this.showDetail(detailRow)
    }
  }

  hideDetail(detail) {
    if (detail) { detail.classList.add("hidden") }
  }

  showDetail(detail) {
    if (detail) { detail.classList.remove("hidden") }
  }
}
